import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Resolve, Router, RouterStateSnapshot, Params } from '@angular/router';
import { Errors, UserService } from '../shared';

@Component({
  selector: 'app-sauth',
  templateUrl: './sauth.component.html',
  styleUrls: ['./sauth.component.css']
})
export class SauthComponent implements OnInit {

  constructor(private userService: UserService, private router: Router, private activatedRoute: ActivatedRoute) { }
  sAuthData: any = {};
  loginAuthData: any = {};
  tokenID: string = "";

  ngOnInit() {

    // if(window.localStorage['plogin'])
    //window.localStorage.clear();

    // alert(window.localStorage['plogin']);

    this.activatedRoute.params.subscribe((params: Params) => {
      let tokenId = params['tokenId'];
      this.tokenID = tokenId;
    });


    this.sLoginAuthentication();
  }

  sLoginAuthentication() {



    const credentials = {}
    this.userService
      .sauth(this.tokenID, credentials)
      .subscribe(
        data => {
          this.sAuthData = data;
          this.mainLoginAuthentication();
        },
        err => {
          // alert("Error Comes");
        }
      );
  }

  mainLoginAuthentication() {
    const credentials = {
      'username': this.sAuthData.AuthInfo.userName,
      'password': this.sAuthData.AuthInfo.password,
      'captcha': '',
      'mode': '',
      'usermode': localStorage.getItem('userMode') ? atob(localStorage.getItem('userMode')) : 'c',
      'forcelogin': 'false'
    };
    this.userService
      .attemptAuth(credentials)
      .subscribe(
        data => {

        },
        err => {

        }
      );
  }

}
